import React, { useState } from "react";
import { Box, Grid, Typography, Checkbox, FormControlLabel } from "@mui/material";
import KenInput from "../../../../../../GlobalComponents/KenInput";
import KenSelect from "../../../../../../GlobalComponents/KenSelect";
import { IAssignment,ISubmissiontype } from "../../Assignment/index"
import { DROP_DOWN } from "../Helper/AssignmentHelper"
interface ISubmission {
    assignData: IAssignment;
    fileFormatLists:ISubmissiontype[];
    handleCheckBoxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSubmissionFileType: (e: React.ChangeEvent<HTMLInputElement>) => void;

}
const SubmissionSettings: React.FC<ISubmission> = ({
    assignData,
    fileFormatLists,
    handleCheckBoxChange,
    handleChange,
    handleSubmissionFileType
}: ISubmission) => {



    return (
        <Box sx={{ p: 2, background: "#F8FAFD", borderRadius: "8px", textAlign: "start" }}>
            {/* Submission Types */}
            <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>
                Submission Types
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={assignData.assignsubmission_onlinetext_wordlimit_enabled ? true : false}
                                onChange={handleCheckBoxChange}
                                name="assignsubmission_onlinetext_wordlimit_enabled"
                                color="primary"
                            />
                        }
                        label="Online Text"
                    />
                </Grid>
                <Grid item>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={assignData.assignsubmission_comments_enabled ? true : false}
                                onChange={handleCheckBoxChange}
                                name="assignsubmission_comments_enabled"
                                color="primary"
                            />
                        }
                        label="File Submission"
                    />
                </Grid>
            </Grid>

            {/* Inputs */}
            <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* Word Limit */
                    assignData.assignsubmission_onlinetext_wordlimit_enabled && <Grid item xs={12} sm={4}>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
                            Word limit
                        </Typography>
                        <KenInput
                            type="number"
                            name="assignsubmission_onlinetext_wordlimit"
                            value={assignData.assignsubmission_onlinetext_wordlimit}
                            onChange={handleChange}
                            placeholder="1000"
                            fullWidth
                        />
                    </Grid>
                }


                {/* Number of Files to Upload */}
                {
                    assignData.assignsubmission_comments_enabled && (<><Grid item xs={12} sm={4}>
                        <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
                            Number of files to upload
                        </Typography>
                        <KenInput
                            type="number"
                            name="assignsubmission_file_maxfiles"
                            value={assignData.assignsubmission_file_maxfiles}
                            onChange={handleChange}
                            placeholder="1"
                            fullWidth
                        />
                    </Grid>

                        {/* Maximum Submission Size */}
                        <Grid item xs={12} sm={4}>
                            <Typography sx={{ fontSize: "14px", fontWeight: 400, mb: 1 }}>
                                Maximum submission size
                            </Typography>
                            <KenSelect
                                selectLabel="Select"
                                name="assignsubmission_file_maxsizebytes"
                                value={assignData.assignsubmission_file_maxsizebytes}
                                handleChange={handleChange}
                                options={DROP_DOWN.fileSize}
                            />
                        </Grid></>)
                }
            </Grid>

            {/* Submission File Format */}
            {assignData.assignsubmission_comments_enabled && <Box sx={{ mt: 2 }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>
                    Submission file format
                </Typography>
                {
                    fileFormatLists.map((x)=>{
                        return   <FormControlLabel
                        control={<Checkbox 
                            checked={x.value}
                            onChange={handleSubmissionFileType}
                            name={x.ext}
                            color="primary"
                            disabled={x.disable}
                             />}
                        label={x.label}
                    />
                    })
                }
              
            </Box>
            }
        </Box>
    );
};

export default SubmissionSettings;
